<app-base-page-template pageTitle="Privacy Policy">
  <app-base-page-content-template>
    <app-pdf-viewer
      [pdfSrc]="'/assets/files/privacy-policy.pdf'">
    </app-pdf-viewer>
  </app-base-page-content-template>
</app-base-page-template>

